module.exports = __webpack_public_path__ + "static/media/cwoc.404ae7bc.png";